const indexItems = [
  { title: '最新电影', desc: '院线新片速递', icon: 'ri-movie-2-line', color: 'text-accent-600', bg: 'bg-accent-100' },
  { title: '电视剧大全', desc: '热门剧集一网打尽', icon: 'ri-tv-2-line', color: 'text-primary-600', bg: 'bg-primary-100' },
  { title: '综艺娱乐', desc: '爆笑综艺不停歇', icon: 'ri-emotion-laugh-line', color: 'text-accent-600', bg: 'bg-accent-100' },
  { title: '动漫追番', desc: '热血番剧更新中', icon: 'ri-rocket-line', color: 'text-primary-600', bg: 'bg-primary-100' },
  { title: '纪录片', desc: '真实世界探索', icon: 'ri-earth-line', color: 'text-secondary-600', bg: 'bg-secondary-100' },
  { title: '华语电影', desc: '国产佳作精选', icon: 'ri-flag-2-line', color: 'text-accent-600', bg: 'bg-accent-100' },
  { title: '欧美大片', desc: '好莱坞震撼巨制', icon: 'ri-global-line', color: 'text-primary-600', bg: 'bg-primary-100' },
  { title: '日韩剧场', desc: '日剧韩剧热播', icon: 'ri-sun-line', color: 'text-accent-600', bg: 'bg-accent-100' },
  { title: '经典老片', desc: '永恒银幕记忆', icon: 'ri-vidicon-line', color: 'text-secondary-600', bg: 'bg-secondary-100' },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">
          影片索引
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">
          九大观影入口，海量高清电影与免费电视剧随心检索
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-5">
          {indexItems.map((item, idx) => (
            <a
              key={idx}
              href="#cards"
              className="group flex flex-col items-center p-5 md:p-6 bg-background-100/70 border border-background-200/60 rounded-xl transition-all duration-200 hover:-translate-y-1 hover:border-primary-200/50 cursor-pointer no-underline"
            >
              <div className={`w-12 h-12 rounded-xl ${item.bg} flex items-center justify-center mb-3 transition-transform duration-200 group-hover:scale-110`}>
                <i className={`${item.icon} ${item.color} text-xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 whitespace-nowrap">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1 whitespace-nowrap">
                {item.desc}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}